module.exports = __webpack_public_path__ + "media/images/vp/icon.heart.darkred-8eed648ee81591ef3d985607a67ebfa1.svg";